// extracted by mini-css-extract-plugin
module.exports = {"userManagement":"UserManagement_userManagement__3tlGI","searchBox":"UserManagement_searchBox__3sk26"};